import { getReportsByUserID } from '@dispatch/shared/services';
import { usePaginatedQuery } from '../api/usePaginatedQuery';
import { useCurrentUser } from '@dispatch/web/auth';
import { ReportsInfoRequest, ReportsListFilter } from '@dispatch/shared/types';

export const useGetReportsByUserID = (
  isReady: boolean,
  expand: boolean,
  filter: ReportsListFilter
) => {
  const { userId } = useCurrentUser();

  const gridDataRequest: ReportsInfoRequest = {
    userId: String(userId),
    expand,
    filter,
  };

  return usePaginatedQuery(
    ['fetchReports', userId, filter],
    (token) => getReportsByUserID(gridDataRequest, token),
    {
      enabled: isReady,
    }
  );
};
